import { render, staticRenderFns } from "./CFooter.vue?vue&type=template&id=2b8efb96"
import script from "./CFooter.vue?vue&type=script&lang=js"
export * from "./CFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports